import apiClient from './api';
import accommodationService from './accommodationService';
import chainService from './chainService';
import neighborhoodService from './neighborhoodService';
import popularLocationService from './popularLocationService';

const staticDataService = {
    getAccommodationTypes: async () => {
        try {
            return await accommodationService.getAccommodations();
        } catch (error) {
            console.error('Error fetching accommodation types:', error);
            return [];
        }
    },

    getBoards: async () => {
        try {
            // Kullanıcı token'ını al
            const userData = JSON.parse(localStorage.getItem('user_data'));
            const token = userData?.token;

            const response = await apiClient.get('boards', {
                headers: {
                    'Authorization': token ? `Bearer ${token}` : ''
                }
            });
            return response.data.data;
        } catch (error) {
            console.error('Error fetching boards:', error);
            return [];
        }
    },

    getChains: async () => {
        try {
            return await chainService.getChains();
        } catch (error) {
            console.error('Error fetching chains:', error);
            return [];
        }
    },

    getNeighborhoods: async () => {
        try {
            return await neighborhoodService.getNeighborhoods();
        } catch (error) {
            console.error('Error fetching neighborhoods:', error);
            return [];
        }
    },

    getPopularLocations: async () => {
        try {
            return await popularLocationService.getPopularLocations();
        } catch (error) {
            console.error('Error fetching popular locations:', error);
            return [];
        }
    },

    // Tüm önbellekleri temizle
    clearCache: () => {
        accommodationService.clearCache();
        chainService.clearCache();
        neighborhoodService.clearCache();
        popularLocationService.clearCache();
    }
};

export default staticDataService; 